import React from "react";
import Header from "../components/diseases/header/header";
import { Footer } from "../components/footer/footer";
import Gallery from "../components/diseases/details/gallery";
import AboutDetails from "../components/diseases/details/aboutDetails";
import { useLocation } from "react-router-dom";

const DiseasesDetails = ({ setViewDiagnosis }) => {
  const { state } = useLocation();
  console.log(state);
  return (
    <div>
      <Header setViewDiagnosis={setViewDiagnosis} />
      <Gallery images={state.img} />
      <AboutDetails image={state.img[0]} />
      <Footer />
    </div>
  );
};

export default DiseasesDetails;
